import { observable, action } from 'mobx';
import { Auth } from 'aws-amplify';
import { User } from '../models/User';

export class UserStore {
  @observable currentUser: User = new User();

  @action loadCurrentUser = async (): Promise<User> => {
    const session: any = await Auth.currentSession();
    this.currentUser = new User({
      username: session.idToken.payload['cognito:username'], 
      subject: session.idToken.payload.sub,
      email: session.idToken.payload.email
    });
    return this.currentUser;
  }
}